<script lang="ts">
	import Confetti from 'svelte-confetti';
	import { push } from 'svelte-spa-router';
	// Design system components
	import {
		IconButton,
		Text,
		Container,
		Button,
		Modal,
		Stack,
		CircleAvatar,
		Input,
		toast,
		Textarea,
		Collapse,
	} from '@Shelly/shelly-design-system';
	import { format } from 'svelte-i18n';
	import { tick } from 'svelte';

	import TestConfetti from './TestConfetti.svelte';
	import ResetRate from './ResetRate.svelte';
	import SendLocalCommandsUtility from './SendLocalCommandsUtility.svelte';
	import DeviceRuntimeInspector from './DeviceRuntimeInspector.svelte';
	import ResetPPandGTC from './ResetPPandGTC.svelte';
	import ResetAlexaIntegrationPrompt from './ResetAlexaIntegrationPrompt.svelte';
	import ResetNewsletter from './ResetNewsletter.svelte';
	import ResetPremiumEventLogAds from './ResetPremiumEventLogAds.svelte';
	import ResetPremiumSceneConditionAds from './ResetPremiumSceneConditionAds.svelte';
	import ResetPremiumWeatherWidgetAds from './ResetPremiumWeatherWidgetAds.svelte';
	import ResetBlePromo from './ResetBlePromo.svelte';
	import {
		energyPriceColorSchemes,
		type ColorSchemeKey,
	} from 'src/components/Consumption/VerivoxEnergyPriceIntegration/utils/colorSchemes';
	import { energyPriceApi } from 'src/components/Consumption/VerivoxEnergyPriceIntegration/api/verivoxApi';

	import { getLandingHref } from 'src/helpers/main_menu';
	import { loadingData } from 'src/stores/ui/loading-data';
	import { refreshDataCalls } from 'src/stores/features/dev/refresh-data-calls';
	import {
		crefresh_token,
		getReq,
		handleToken,
		postReq,
		pullDataWithLoading,
	} from 'src/services/http';
	import ResetWhatsNewFeatures from './ResetWhatsNewFeatures.svelte';
	import ResetHomesOnboarding from './ResetHomesOnboarding.svelte';
	import ResetGlobalTempUnit from './ResetGlobalTempUnit.svelte';
	import { user_data, user_settings } from 'src/stores/account/user';
	import { devices } from 'src/stores/lists/devices';
	import { app as NativeApp, os } from 'src/stores/session/native-bridge';
	import { testDemoPromotionsModals } from 'src/stores/ui/promotions';
	import { aiSceneChatStore } from 'src/stores/features/ai-scene-chat';
	import { delete_home, save_home } from 'src/helpers/home_helpers';
	import { delete_profile, save_profile } from 'src/helpers/profile_helpers';
	import { home_data, profile_data } from 'src/stores/account/user';
	import { get } from 'svelte/store';
	import { HttpClient } from 'src/services/utils/http-client';

	// Import DUI functions
	import { duiSave, duiSaveField, duiDelete, duiList } from 'src/services/php-api/device_ui';
	import { device_ui } from 'src/stores/features/device-ui';
	import type { DeviceUI, DeviceUIField } from 'src/types/DeviceUI';
	import {
		askForSecuritySettings,
		showBiometricAuthAndroid,
		load_asset_android,
	} from 'src/services/native_container_requests_android';
	import { biometry_store } from 'src/stores/features/biometry';
	import { showBiometricAuthIos, load_asset_ios } from 'src/services/native_container_requests_ios';
	import { pin_unlocked_devices } from 'src/stores/device-runtime/pin-unlocked';
	import { isRepoUser } from 'src/helpers/user_server_conditions';
	import { isSubUnit } from 'src/helpers/user_helpers';
	import { sidepanelDesktopOnTop } from 'src/stores/ui/sidepanel';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import { eventLogV2Enabled } from 'src/stores/event_log_v2_enabled';
	import {
		safeAreaDebugEnabled,
		setSafeAreaDebugEnabled,
	} from 'src/stores/features/dev/safe-area-debug';

	export let openDevModal = false;

	const FE_ENV_MONITOR_URL = 'https://fe-env-monitor.shelly.link';

	let testConfetti = false;
	let duiSectionOpen = false;
	let envMonitorSectionOpen = false;
	let isSubUnitSectionOpen = false;
	let deviceRuntimeSectionOpen = false;
	let energyPriceScheme: ColorSchemeKey = 'scheme1';
	//Expired token for JJ
	let expiredTokenJJ =
		'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJwd2QiLCJpYXQiOjE3NDY2MzgzNzcsInVzZXJfaWQiOiIxMTI4MTAyIiwic24iOiI1IiwidXNlcl9hcGlfdXJsIjoiaHR0cHM6XC9cL3JlcG8uc2hlbGx5LmNsb3VkIiwibiI6MTgxNSwiZXhwIjoxNzQ2NjM4Njc3fQ.vekcuk_f9a4pTZSrtvYP3kHVr0ypl-HpFAOoTGMhloI';
	//Expired refresh token for JJ
	// @ToDo: Update with test token for JJ
	let invalidRefreshTokenJJ =
		'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJpb3R1LzEiLCJzdWIiOiIzMjM2NDk0IiwiYXVkIjoicHdkIiwic24iOiIzIiwiaWF0IjoxNzUwMjc1MjU1LCJqdGkiOjk2MzQsImV4cCI6MTc1NTQ1OTI1NX0.AHl6wv_RiR_KxAxOQXrjmDChQIbCBSYeKnwNjSCAIr';
	let expiredRefreshTokenJJ =
		'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJpb3R1LzEiLCJzdWIiOiIxMTI4MTAyIiwiYXVkIjoicHdkIiwic24iOiI1IiwiaWF0IjoxNzUwMjc3MTA1LCJqdGkiOjE5OTEsImV4cCI6MTc1MDM2MzUwNX0.4SDj3941MBNP3Lu2_mvZcHXeFS_27ea4egLb9Poyf60';

	$: biometricAuthResponse = $biometry_store;

	$: customToken = $user_data.token;

	let loadAssetUrl = 'https://control.shelly.cloud/assets/en-312f84b7.js';

	const loadAsset = async () => {
		try {
			let blob = null;
			if ($os === 'IOS') {
				blob = await load_asset_ios(loadAssetUrl);
			} else {
				blob = await load_asset_android(loadAssetUrl);
			}

			// Convert Blob to text
			const text = await blob.text();

			// Try to parse as JSON, if it fails it's likely a JS file
			let data;
			let isJson = false;
			try {
				data = JSON.parse(text);
				isJson = true;
			} catch {
				// Not JSON, treat as text (e.g., JavaScript file)
				data = text;
			}

			// If it's JSON, check for error response
			if (isJson && data.isok === false) {
				const errorMessage = data.errors?.[Object.keys(data.errors || {})[0]] || 'Unknown error';
				console.error('Asset load error:', data);
				throw new Error(errorMessage);
			}

			toast.open({
				type: 'success',
				title: 'Asset loaded successfully',
			});
			console.log('Asset loaded data:', data);
		} catch (error) {
			toast.open({
				type: 'danger',
				title: 'Error loading asset',
				text: error?.message || '',
			});
			console.error('Error loading asset:', error);
		}
	};

	//#region Device UI Data Variables
	// Device UI Data variables
	let deviceId = '';
	let duiKey = '';
	let duiFieldData = '';
	let duiDeviceData = '';

	// DUI function handlers

	const handleDuiSaveField = async () => {
		try {
			const result = await duiSaveField(
				deviceId,
				duiKey as DeviceUIField,
				duiFieldData as unknown as DeviceUI[DeviceUIField],
			);
			console.log('DUI Update Field result:', result);

			if (!result.isok) {
				throw new Error(
					result?.errors?.[Object.keys(result?.errors || {})[0]] || 'Unknown error',
				);
			}

			toast.open({
				type: 'success',
				title: 'DUI field updated successfully',
			});
		} catch (error) {
			console.error('DUI Update Field error:', error);
			toast.open({
				type: 'danger',
				title: 'Error updating DUI field',
				text: error?.message || '',
			});
		}
	};

	const handleDuiSave = async () => {
		try {
			const data = JSON.parse(duiDeviceData);
			const result = await duiSave(deviceId, data);
			console.log('DUI Save result:', result);

			if (!result.isok) {
				throw new Error(
					result?.errors?.[Object.keys(result?.errors || {})[0]] || 'Unknown error',
				);
			}
			toast.open({
				type: 'success',
				title: 'DUI data saved successfully',
			});
		} catch (error) {
			console.error('DUI Save error:', error);
			toast.open({
				type: 'danger',
				title: 'Error saving DUI data',
				text: error?.message || '',
			});
		}
	};

	const handleDuiDelete = async () => {
		try {
			const result = await duiDelete(deviceId);
			console.log('DUI Delete result:', result);
			if (!result.isok) {
				throw new Error(
					result?.errors?.[Object.keys(result?.errors || {})[0]] || 'Unknown error',
				);
			}
			toast.open({
				type: 'success',
				title: 'DUI data deleted successfully',
			});
		} catch (error) {
			console.error('DUI Delete error:', error);
			toast.open({
				type: 'danger',
				title: 'Error deleting DUI data',
				text: error?.message || '',
			});
		}
	};

	const handleDuiList = async () => {
		try {
			const result = await duiList();
			console.log('DUI List result:', result);
			if (!result.isok) {
				throw new Error(
					result?.errors?.[Object.keys(result?.errors || {})[0]] || 'Unknown error',
				);
			}
			toast.open({
				type: 'success',
				title: 'DUI list retrieved successfully',
			});
		} catch (error) {
			console.error('DUI List error:', error);
			toast.open({
				type: 'danger',
				title: 'Error retrieving DUI list',
			});
		}
	};
	//#endregion

	const handlePullDown = (e) => {
		if (!$loadingData) {
			const timeStamp = Date.now();
			refreshDataCalls.customUpdate(timeStamp);
			pullDataWithLoading(); // calls => handleInitialLoad
		}
	};

	const resetPremiumData = async () => {
		await getReq('https://test-paypal.shelly.cloud/api/reset-subscription', {})
			.then(() => {
				alert('Premium data reset');
			})
			.catch(() => {
				alert('Error resetting premium data');
			});
	};

	const deleteVoucherFromAccount = async () => {
		try {
			let token = localStorage.getItem('user_data')
				? JSON.parse(localStorage.getItem('user_data')).token
				: null;
			let infraInstance = new HttpClient(
				isRepoUser()
					? import.meta.env.VITE_REPO_VOUCHER_URL_TEST
					: import.meta.env.VITE_VOUCHER_URL_TEST,
			);
			infraInstance.setAuthToken(token);
			let request = await infraInstance.delete('/coupons/active_coupons');
			console.log('deleteVoucherFromAccount', request);
			if (request.status === 200) {
				toast.open({
					type: 'success',
					title: 'Voucher deleted successfully',
				});
			}
		} catch (error) {
			toast.open({
				type: 'error',
				title: 'Error deleting voucher from account',
			});
			console.error('Error deleting voucher from account:', error);
		}
	};
	const testThrowError = () => {
		throw new Error('Test runtime error');
	};
	const testRuntimeError = (e) => {
		e.testRuntimeError.length;
	};
	const testCaughtError = (e) => {
		try {
			e.testCaughtError.length;
		} catch (error) {
			console.log('Caught test error', error);
		}
	};
	const testConsoleError = (e) => {
		console.error('Console.error: test error', e);
	};

	const sendBiometricsRequest = async () => {
		const platform = get(os);

		if (platform === 'IOS') {
			const respone = await showBiometricAuthIos(
				'This is biometry',
				'Do you agree to pay me 43 BTC?', // description
				'I agree but I burnt my finger ( 🤫 this is cancel text 🤫)', // cancel
			);
			console.log('Biometric auth response:', respone);
			return;
		}

		const respone = await showBiometricAuthAndroid(
			'This is biometry',
			'Chakarakachooo',
			'Do you agree to pay me 43 BTC?',
			'I agree but I burnt my finger ( 🤫 this is cancel text 🤫)',
		);
		console.log('Biometric auth response:', respone);
	};

	const clearPinUnlockedDevices = async () => {
		const ds = get(devices);

		for (const [id, device] of Object.entries(ds)) {
			pin_unlocked_devices.remove_device(device);
		}
	};

	const askForSecurity = async () => {
		const respone = await askForSecuritySettings();
		console.log('Ask for security:', respone);
	};

	const handleEnergyPriceSchemeChange = (scheme: ColorSchemeKey) => {
		energyPriceScheme = scheme;
		energyPriceColorSchemes.setCurrentScheme(scheme);
		window.location.reload();
	};

	const clearCachedPostalCode = async () => {
		try {
			await energyPriceApi.clearCachedLocation();
			toast.open({
				type: 'success',
				title: 'Cached postal code cleared',
			});
		} catch (error) {
			console.error('Failed to clear cached postal code:', error);
			toast.open({
				type: 'danger',
				title: 'Error clearing cached postal code',
			});
		}
	};

	const enableVerivoxIntegration = async () => {
		const profileData = get(profile_data);
		const deUsersData = {
			verivox_integration: profileData?.de_users?.verivox_integration || {
				postalCode: '10115',
				locationId: '7083',
				locationString: 'Berlin / Mitte',
				annualConsumption: 2500,
				consumptionPreference: 'average',
			},
		};
		let res = await save_profile('de_users', deUsersData);
		if (!res?.isok) {
			console.error('Failed to enable Verivox integration:', res?.error);
			toast.open({
				type: 'danger',
				title: 'Error enabling Verivox integration',
			});
			return;
		}
		toast.open({
			type: 'success',
			title: 'Verivox integration enabled (de_users set)',
		});
	};

	const removeVerivoxHomeData = async () => {
		try {
			await delete_profile('de_users');

			profile_data.update((current) => {
				const updated = { ...current };
				delete updated.de_users;
				return updated;
			});

			toast.open({
				type: 'success',
				title: 'Verivox home data removed (de_users deleted)',
			});
		} catch (error) {
			console.error('Failed to remove Verivox home data:', error);
			toast.open({
				type: 'danger',
				title: 'Error removing Verivox home data',
			});
		}
	};

	const clearEnergyPriceDismissal = () => {
		try {
			// Clear any dismissal-related localStorage keys
			const keysToRemove = [
				'shelly_energy_price_dismissed',
				'shelly_energy_price_dismissal_date',
				'shelly_energy_suggestion_dismissed',
			];
			let cleared = false;
			keysToRemove.forEach((key) => {
				if (localStorage.getItem(key)) {
					localStorage.removeItem(key);
					cleared = true;
				}
			});
			if (cleared) {
				toast.open({
					type: 'success',
					title: 'Energy price dismissal state cleared',
				});
			} else {
				toast.open({
					type: 'info',
					title: 'No dismissal state found',
				});
			}
		} catch (error) {
			console.error('Failed to clear dismissal state:', error);
			toast.open({
				type: 'danger',
				title: 'Error clearing dismissal state',
			});
		}
	};

	$: schemeKeys = Object.keys(energyPriceColorSchemes.schemes) as ColorSchemeKey[];

	$: if (openDevModal && !energyPriceScheme) {
		energyPriceScheme = energyPriceColorSchemes.getCurrentScheme();
	}

	const resetNewLayoutOnboarding = async () => {
		profile_data.set({ ...get(profile_data), newLayoutOnboardingSeen: { seen: false } });
		save_profile('newLayoutOnboardingSeen', { seen: false });

		openDevModal = false;
		// Let the dev modal unmount before opening the onboarding modal.
		await tick();
		showNewLayoutOnboarding.set(true);
	};

	const toggleSidepanelDesktopOnTop = (bool: boolean = true) => {
		sidepanelDesktopOnTop.set(bool);
		return;
	};

	const setEventLogV2Enabled = (enabled: boolean) => {
		eventLogV2Enabled.set(enabled);
		toast.open({
			type: 'info',
			title: `Event log ${enabled ? 'V2' : 'V1'} enabled`,
			text: 'Reload Activity log to apply.',
		});
	};

	/**
	 *  tmpk_valid is stored as a 'YYYY-MM-DD HH:MM:SS' string (see GrantAccess.svelte).
	 *	Set it to an old date so support access reads as expired.
	 */
	const setExpiredSupportAccess = () => {
		const oldDate = new Date('2000-01-01T00:00:00');
		const pad = (n: number) => `${n}`.padStart(2, '0');
		const tmpkValid =
			`${oldDate.getFullYear()}-${pad(oldDate.getMonth() + 1)}-${pad(oldDate.getDate())} ` +
			`${pad(oldDate.getHours())}:${pad(oldDate.getMinutes())}:${pad(oldDate.getSeconds())}`;

		user_data.set({
			...get(user_data),
			tmpk_valid: tmpkValid,
		});

		console.log('Set expired tmpk_valid', tmpkValid);
		toast.open({
			type: 'success',
			title: 'Set expired support access (tmpk_valid)',
			text: tmpkValid,
		});
	};
</script>

<Modal
	showModal={openDevModal}
	on:close={() => {
		openDevModal = false;
	}}
	title={'Dev Utilities'}
	backdropClose={false}
>
	<Stack slot="content" gap="m" class="d-flex flex-direction-column">
		<Stack gap="s" class="d-flex align-items-center mb-l">
			<CircleAvatar size="l" image={'./images/dev/arny.jpeg'} />

			<Button
				variant="danger"
				on:click={() => {
					localStorage.clear();
					window.location.reload();
				}}
			>
				Total Logout!
			</Button>

			<Button
				variant="danger"
				on:click={() => {
					resetPremiumData();
				}}
			>
				Reset Premium
			</Button>
			<Button
				variant="danger"
				on:click={() => {
					deleteVoucherFromAccount();
				}}
			>
				Delete Voucher
			</Button>
		</Stack>

		<Container padding="0">
			<Collapse
				id="device-runtime-inspector-section"
				title="Device Runtime Inspector"
				expanded={deviceRuntimeSectionOpen}
				on:click={() => (deviceRuntimeSectionOpen = !deviceRuntimeSectionOpen)}
				class="mb-m"
			>
				<DeviceRuntimeInspector onRefresh={() => handlePullDown(undefined)} />
			</Collapse>
		</Container>

		<hr class="mb-s mt-s" />

		<Container padding="0">
			<Collapse
				id="env-monitor-section"
				title="Sub Unit info"
				expanded={isSubUnitSectionOpen}
				on:click={() => (isSubUnitSectionOpen = !isSubUnitSectionOpen)}
				class="mb-m"
			>
				<Text>is Sub: {isSubUnit()}</Text>
				<Text>is Sub return value: {get(user_settings)?.sub}</Text>
				<Text>Unit info</Text>
				{#each Object.entries(get(user_data)?.own_units || {}) as [id, data] (id)}
					<Text>{id}: {data.name}</Text>
				{/each}
				<Text>Sub units</Text>
				{#each Object.entries(get(user_data)?.sub_units || {}) as [id, data] (id)}
					<Text>{id}: {data.name}</Text>
				{/each}
			</Collapse>
		</Container>

		<hr class="mb-s mt-s" />

		<Container padding="0">
			<Collapse
				id="env-monitor-section"
				title="FE Env Monitor"
				expanded={envMonitorSectionOpen}
				on:click={() => (envMonitorSectionOpen = !envMonitorSectionOpen)}
				class="mb-m"
			>
				<Stack gap="s" class="mb-l">
					<Stack gap="s" class="d-flex align-items-center">
						<Text styleType="body-small" class="mb-0"
							>Dev environment status. Open in new tab if embedding is blocked.</Text
						>
						<Button
							variant="secondary"
							size="s"
							on:click={() =>
								window.open(FE_ENV_MONITOR_URL, '_blank', 'noopener,noreferrer')}
						>
							Open in new tab
						</Button>
					</Stack>
					<Container padding="0">
						<iframe
							src={FE_ENV_MONITOR_URL}
							title="FE Environment Monitor"
							class="env-monitor-iframe width-full"
							loading="lazy"
						/>
					</Container>
				</Stack>
			</Collapse>
		</Container>

		<hr class="mb-s mt-s" />
		<Container padding="0">
			<Text styleType="h2" class="mb-m">Reinitialize</Text>
			<Stack gap="m" class="d-flex align-items-center">
				<Button
					class="width-md-xl width-sm-full"
					icon="fas fa-arrows-rotate"
					on:click={() => window.location.reload()}
				>
					Reload App
				</Button>
				<Button
					variant="secondary"
					class="width-md-xl width-sm-full"
					icon="fas fa-download"
					on:click={(e) => handlePullDown(e)}
				>
					Refresh Data</Button
				>
			</Stack>
		</Container>

		<hr class="mb-s mt-s" />

		<Container padding="0">
			<Text styleType="h2" class="mb-m text-bold">Reset New Layout Onboarding</Text>
			<Text class="mb-s"
				>Shows the new layout onboarding modal again. (resets $profile_data ->
				`newLayoutOnboardingSeen`)</Text
			>
			<Button variant="secondary" on:click={() => resetNewLayoutOnboarding()}>
				Reset & Show Onboarding
			</Button>
			<Text styleType="h2" class="mb-m">Activity log</Text>
			<Text styleType="body-small" class="mb-m">
				Switch between event log V1 (positional payloads) and V2 (JSON payloads). Setting is
				saved locally.
			</Text>
			<Stack gap="m" class="d-flex align-items-center mb-m">
				<Button
					variant={$eventLogV2Enabled ? 'primary' : 'secondary'}
					icon="fas fa-list-timeline"
					on:click={() => setEventLogV2Enabled(true)}
				>
					Event Log V2
				</Button>
				<Button
					variant={!$eventLogV2Enabled ? 'primary' : 'secondary'}
					icon="fas fa-list"
					on:click={() => setEventLogV2Enabled(false)}
				>
					Event Log V1
				</Button>
			</Stack>
			<Text styleType="body-small" class="mt-s">
				Current mode: <b>{$eventLogV2Enabled ? 'V2' : 'V1'}</b>
			</Text>
		</Container>

		<hr class="mb-s mt-s" />

		<Container padding="0">
			<Text styleType="h2" class="mb-m text-bold">Safe area debug</Text>
			<Text styleType="body-small" class="mb-m">
				Shows a red top ruler sized to <code>env(safe-area-inset-top)</code> and a metrics
				panel. Use it to see whether a large top gap is CSS safe-area, stacked padding, or
				native WebView inset. Preference is saved locally.
			</Text>
			<Stack gap="m" class="d-flex align-items-center mb-m">
				<Button
					variant={$safeAreaDebugEnabled ? 'primary' : 'secondary'}
					icon="fas fa-ruler-combined"
					on:click={() => setSafeAreaDebugEnabled(true)}
				>
					Enable
				</Button>
				<Button
					variant={!$safeAreaDebugEnabled ? 'primary' : 'secondary'}
					icon="fas fa-eye-slash"
					on:click={() => setSafeAreaDebugEnabled(false)}
				>
					Disable
				</Button>
			</Stack>
			<Text styleType="body-small" class="mt-s">
				Current: <b>{$safeAreaDebugEnabled ? 'On' : 'Off'}</b>
			</Text>
		</Container>

		<hr class="mb-s mt-s" />

		<Container padding="0">
			<Text styleType="h2" class="mb-m">Sidepanel behavior</Text>
			<Text styleType="body-small" class="mb-m">
				Controls how the sidepanel behaves on desktop screens.
			</Text>
			<Stack gap="m" class="d-flex align-items-center mb-m">
				<Button
					variant={$sidepanelDesktopOnTop ? 'primary' : 'secondary'}
					icon="fas fa-layer-group"
					on:click={() => toggleSidepanelDesktopOnTop(true)}
				>
					Always on Top
				</Button>
				<Button
					variant={!$sidepanelDesktopOnTop ? 'primary' : 'secondary'}
					icon="fas fa-sidebar-flip"
					on:click={() => toggleSidepanelDesktopOnTop(false)}
				>
					Hide / Show
				</Button>
			</Stack>

			<Text styleType="body-small" class="mt-s">
				<b>Always on Top</b> — sidepanel is pinned and always visible alongside content.
			</Text>
			<Text styleType="body-small" class="mt-s"
				><b>Hide/Show</b> — sidepanel can be collapsed and toggled by the user.</Text
			>
		</Container>

		<hr class="mb-s mt-s" />

		<Container padding="0">
			<Text styleType="h2" class="mb-m">Mobile: Dynamic load assets</Text>

			<Input
				size="m"
				type="text"
				id="load-asset-url-input"
				aria-labelledby="load-asset-url-input"
				label="Load Asset URL"
				placeholder="Enter load asset URL"
				bind:value={loadAssetUrl}
				class="width-md-xl width-sm-full"
			/>

			<Button variant="secondary" on:click={loadAsset} class="width-md-xl width-sm-full">
				Load Asset
			</Button>
		</Container>

		<hr class="mb-s mt-s" />

		<Container padding="0">
			<Text styleType="h2" class="mb-m">Device UI Data</Text>
			<Collapse
				id="dui-data-requests"
				title="DUI Data Requests"
				expanded={duiSectionOpen}
				on:click={() => (duiSectionOpen = !duiSectionOpen)}
				class="mb-m"
			>
				<Stack gap="s" class="mb-l">
					<Button
						variant="secondary"
						on:click={handleDuiList}
						class="width-md-xl width-sm-full"
					>
						DUI List
					</Button>
					<hr class="mb-m mt-m" />

					<Text styleType="h2" class="mb-m">Single field</Text>

					<Input
						size="m"
						type="text"
						id="device-id-input"
						aria-labelledby="device-id-input"
						label="Device ID"
						placeholder="Enter device ID"
						bind:value={deviceId}
						class="width-md-xl width-sm-full"
					/>

					<Input
						size="m"
						type="text"
						id="dui-key-input"
						aria-labelledby="dui-key-input"
						label="DUI Key"
						placeholder="Enter DUI key"
						bind:value={duiKey}
						class="width-md-xl width-sm-full"
					/>

					<Textarea
						size="m"
						id="dui-data-input"
						aria-labelledby="dui-data-input"
						label="DUI Field Value (JSON)"
						placeholder="Enter DUI data as JSON"
						bind:value={duiFieldData}
						class="width-md-xl width-sm-full"
					/>

					<Stack gap="m" class="d-flex align-items-center">
						<Button
							variant="primary"
							class="width-md-xl width-sm-full"
							on:click={handleDuiSaveField}
							disabled={!deviceId || !duiKey || !duiFieldData}
						>
							DUI Update Field
						</Button>
						<Button
							variant="secondary"
							on:click={() =>
								(duiFieldData = device_ui.getDeviceUIField(deviceId, duiKey))}
							disabled={!deviceId || !duiKey}
						>
							Get (Store)
						</Button>
					</Stack>
					<hr class="mb-m mt-m" />
					<Text styleType="h2" class="mb-m">Device Data</Text>

					<Input
						size="m"
						type="text"
						id="device-id-input"
						aria-labelledby="device-id-input"
						label="Device ID"
						placeholder="Enter device ID"
						bind:value={deviceId}
						class="width-md-xl width-sm-full"
					/>

					<Textarea
						size="m"
						id="dui-data-input"
						aria-labelledby="dui-data-input"
						label="DUI Data (JSON)"
						placeholder="Enter DUI data as JSON"
						bind:value={duiDeviceData}
						class="width-md-xl width-sm-full"
					/>
					<Stack gap="m" class="d-flex align-items-center">
						<Button
							variant="primary"
							on:click={handleDuiSave}
							class="width-md-xl width-sm-full"
							disabled={!deviceId || !duiDeviceData}
						>
							DUI Save Device
						</Button>
						<Button
							variant="secondary"
							on:click={() =>
								(duiDeviceData = JSON.stringify(device_ui.getDeviceUI(deviceId)))}
							disabled={!deviceId}
						>
							Get (Store)
						</Button>
					</Stack>
					<Button
						variant="danger"
						on:click={handleDuiDelete}
						class="width-md-xl width-sm-full"
						disabled={!deviceId}
					>
						DUI Delete Device
					</Button>
				</Stack>
			</Collapse>
		</Container>

		<hr class="mb-s mt-s" />

		<Container padding="0">
			<Text styleType="h2" class="mb-m text-bold">Authentication Data</Text>
			<Button
				on:click={() => {
					user_data.set({
						...get(user_data),
						password: 'wrong',
					});
				}}>Set Wrong Password</Button
			>

			<Button
				variant="secondary"
				class="ml-l"
				on:click={setExpiredSupportAccess}
				aria-label="Set expired support access date to tmpk_valid"
			>
				Set Expired Support Access
			</Button>

			<hr class="mt-l mb-l" />
			<Text class="mb-m text-bold">Refresh Token</Text>
			<Stack gap="m" class="d-flex align-items-center flex-direction-column">
				<Button
					variant="primary"
					class="width-full"
					on:click={() => {
						user_data.set({
							...get(user_data),
							refresh_token: expiredRefreshTokenJJ,
						});
						console.log('Setting Expired JJ Refresh Token', expiredRefreshTokenJJ);
					}}>Set Expired</Button
				>
				<Button
					variant="secondary"
					class="width-full"
					on:click={() => {
						user_data.set({
							...get(user_data),
							refresh_token: invalidRefreshTokenJJ,
						});
						console.log('Setting Invalid JJ Refresh Token', invalidRefreshTokenJJ);
					}}>Set Invalid</Button
				>
				<Button
					variant="danger"
					class="width-full"
					on:click={() => {
						let udata = get(user_data);
						if (udata.refresh_token) delete udata.refresh_token;
						user_data.set(udata);
						console.log('Deleted Refresh Token');
					}}>Delete Refresh Token</Button
				>
			</Stack>

			<hr class="mt-l mb-l" />

			<Text class="mb-m text-bold">Auth token</Text>

			<Button
				variant="secondary"
				class="mb-m width-full"
				on:click={() => {
					user_data.set({
						...get(user_data),
						token: expiredTokenJJ,
					});
					customToken = expiredTokenJJ;
					console.log('Setting Expired JJ Token', expiredTokenJJ);
					handleToken(expiredTokenJJ);
				}}>Set Expired Token</Button
			>
			<Input
				class="mb-m"
				size="l"
				type="text"
				id="input-auth-token"
				label={'Auth token'}
				aria-labelledby="input-auth-token"
				value={customToken}
				on:click={(e) => {
					e.target.select();
				}}
				on:input={(e) => {
					customToken = e?.detail?.value;
				}}
			/>
			<Button
				on:click={() => {
					user_data.set({
						...get(user_data),
						token: customToken,
					});
					console.log('customToken', customToken);
					handleToken(customToken);
				}}>Set Auth Token</Button
			>

			<Button
				variant="secondary"
				class="ml-l"
				on:click={() => {
					customToken = get(user_data)?.token;
				}}>Get Current Token</Button
			>

			<hr class="mt-l mb-l" />

			<Text class="mb-m text-bold">Data loaders</Text>
			<Button
				class="width-full"
				on:click={() => {
					pullDataWithLoading();
				}}>Initial data load</Button
			>
		</Container>

		<hr class="mb-s mt-s" />

		<Container padding="0">
			<Text styleType="h2" class="mb-m text-bold">Clear Installers home data</Text>
			<Button
				variant="primary"
				on:click={() => {
					delete_home('icodes');
					delete_home('installers_time');
				}}
			>
				Clear Installers home data</Button
			>
		</Container>

		<hr class="mb-s mt-s" />

		<Container padding="0">
			<Text styleType="h2" class="mb-m text-bold">Reset What's New Features</Text>
			<ResetWhatsNewFeatures />
		</Container>

		<hr class="mb-s mt-s" />

		<Container padding="0">
			<Text styleType="h2" class="mb-m">Reset Houses Onboarding</Text>
			<ResetHomesOnboarding />
		</Container>

		<hr class="mb-s mt-s" />

		<Container padding="0">
			<Text styleType="h2" class="mb-m">Reset App Icon</Text>
			<Text styleType="h2" class="mb-m text-bold">Reset App Icon</Text>
			<Button
				on:click={() => {
					save_home('appIconModal', 1680455849);
				}}>Reset App Icon</Button
			>
		</Container>

		<hr class="mb-s mt-s" />

		<Container padding="0">
			<Text styleType="h2" class="mb-m text-bold">Reset Proactive Black Friday Modal</Text>
			<Button
				variant="primary"
				on:click={() => {
					save_profile('promotions', {
						blackFriday: {
							...$profile_data?.promotions?.blackFriday,
							proactive: 0,
						},
					});
				}}
			>
				Reset</Button
			>
		</Container>

		<hr class="mb-s mt-s" />

		<Container padding="0">
			<Text styleType="h2" class="mb-m text-bold">Reset Ble Promo</Text>
			<ResetBlePromo />
		</Container>

		<hr class="mb-s mt-s" />

		<Container padding="0">
			<Text styleType="h2" class="mb-m text-bold">Reset AI Chat Onboarding</Text>
			<Text class="mb-s"
				>След reset потребителят ще види onboarding модала при следващо отваряне на AI Assistant.</Text
			>
			<Stack gap="s" class="d-flex align-items-center">
				<Button variant="secondary" on:click={() => aiSceneChatStore.resetOnboarding()}>
					Reset Onboarding
				</Button>
				<Button variant="secondary" on:click={() => aiSceneChatStore.resetChatPopovers()}>
					Reset In-Modal Popovers
				</Button>
			</Stack>
		</Container>

		<hr class="mb-s mt-s" />

		<Container padding="0">
			<Text styleType="h2" class="mb-m text-bold">Reset Promotions</Text>
			<Button
				class="mb-s"
				on:click={() =>
					save_profile('promotions', {
						...$profile_data?.promotions,
						annualSurvey: 0,
					})}>Reset Annual Survey</Button
			>
			<Button
				class="mb-s"
				on:click={() =>
					testDemoPromotionsModals.update((prevState) => ({
						...prevState,
						birthday: true,
					}))}>Show Birthday Offer</Button
			>
			<Button
				class="mb-s"
				on:click={() =>
					testDemoPromotionsModals.update((prevState) => ({
						...prevState,
						black_friday: true,
					}))}>Show Black Friday Offer</Button
			>
			<Button class="mb-s" on:click={() => save_profile('isShowedExpirationPremium', 'no')}
				>Reset Expiration Premium</Button
			>
			{#if $user_data.premium}
				<Button class="mb-s" on:click={() => save_profile('promoPremium', '1.1.1')}
					>Show Promo Premium</Button
				>
			{:else}
				<Button on:click={() => save_profile('promoBasic', '1.1.1')}>Show Promo Basic</Button>
			{/if}
		</Container>

		<hr class="mb-s mt-s" />

		<Container padding="0">
			<Text styleType="h2" class="mb-m text-bold">ResetCampaigns</Text>
			<Button
				on:click={() => {
					if ($profile_data?.earthDaySceneCreated) {
						delete_profile('earthDaySceneCreated');
					}
					if ($profile_data?.aep?.ed) {
						const clonedAep = $profile_data?.aep;
						delete clonedAep.ed;
						profile_data.set({
							...$profile_data,
							aep: clonedAep,
						});
					}
					save_profile('promotions', {
						...$profile_data?.promotions,
						earthDay: 0,
					});
				}}>Earth Day</Button
			>
			<Button
				class="mb-s"
				on:click={() => {
					if ($profile_data?.promotions?.spinWheel) {
						save_profile('promotions', {
							...$profile_data?.promotions,
							spinWheel: 0,
						});
					}
				}}>Spin Wheel</Button
			>
			<Button
				class="mb-s"
				on:click={() => {
					if ($profile_data?.promotions?.smartHomeChallenge) {
						save_profile('promotions', {
							...$profile_data?.promotions,
							smartHomeChallenge: 0,
						});
					}
				}}>Smart Home Challenge</Button
			>
			<Button
				class="mb-s"
				on:click={() => {
					if ($profile_data?.promotions?.shellyBirthdayTeaser) {
						save_profile('promotions', {
							...$profile_data?.promotions,
							shellyBirthdayTeaser: 0,
						});
					}
				}}>Shelly Birthday Teaser</Button
			>
			<Button
				class="mb-s"
				on:click={() => {
					if ($profile_data?.promotions?.shellyBirthdayCampaign) {
						save_profile('promotions', {
							...$profile_data?.promotions,
							shellyBirthdayCampaign: 0,
						});
					}
				}}>Shelly Birthday Campaign</Button
			>
			<Button
				class="mb-s"
				on:click={() => {
					if ($profile_data?.promotions?.blackFridayPhase1) {
						save_profile('promotions', {
							...$profile_data?.promotions,
							blackFridayPhase1: 0,
						});
					}
				}}>Black Friday Phase 1</Button
			>
			<Button
				class="mb-s"
				on:click={() => {
					if ($profile_data?.promotions?.blackFridayPhase2) {
						save_profile('promotions', {
							...$profile_data?.promotions,
							blackFridayPhase2: 0,
						});
					}
				}}>Black Friday Phase 2</Button
			>
			<Button
				class="mb-s"
				on:click={() => {
					if ($profile_data?.promotions?.annualSurvey2026) {
						save_profile('promotions', {
							...$profile_data?.promotions,
							annualSurvey2026: 0,
						});
					}
				}}>Annual Survey 2026</Button
			>
			<Button
				class="mb-s"
				on:click={() => {
					if ($profile_data?.promotions?.thirtyMillionDevices) {
						save_profile('promotions', {
							...$profile_data?.promotions,
							thirtyMillionDevices: 0,
						});
					}
				}}>30 Million Devices</Button
			>
			<Button
				class="mb-s"
				on:click={() => {
					if ($profile_data?.promotions?.xlX2FlashDeal) {
						save_profile('promotions', {
							...$profile_data?.promotions,
							xlX2FlashDeal: 0,
						});
					}
				}}>WallDisplay Flash Sale</Button
			>
			<Button
				class="mb-s"
				on:click={() => {
					if ($profile_data?.promotions?.wallDisplayFlashSale2) {
						save_profile('promotions', {
							...$profile_data?.promotions,
							wallDisplayFlashSale2: 0,
						});
					}
				}}>Wall Display Flash Sale vol.2</Button
			>
			<Button
				class="mb-s"
				on:click={() => {
					if ($profile_data?.promotions?.springDeals2026) {
						save_profile('promotions', {
							...$profile_data?.promotions,
							springDeals2026: 0,
						});
					}
				}}>Spring Deals 2026</Button
			>
			<Button
				class="mb-s"
				on:click={() => {
					if ($profile_data?.promotions?.smartHomeChallenge2026) {
						save_profile('promotions', {
							...$profile_data?.promotions,
							smartHomeChallenge2026: 0,
						});
					}
				}}>Smart Home Challenge 2026</Button
			>
			<Button
				on:click={() => {
					if ($profile_data?.promotions?.shellyBirthday2026) {
						save_profile('promotions', {
							...$profile_data?.promotions,
							shellyBirthday2026: 0,
						});
					}
				}}>Shelly Birthday 2026</Button
			>
		</Container>

		<hr class="mb-s mt-s" />

		<Container padding="0">
			<Text styleType="h2" class="mb-m text-bold">Runtime errors</Text>
			<Button variant="danger-secondary" on:click={() => testThrowError()}>Throw error</Button>
			<Button variant="danger" on:click={(e) => testRuntimeError(e)}>Critical Runtime error</Button
			>
			<Button variant="primary" on:click={(e) => testCaughtError(e)}>Caught error</Button>
			<Button variant="secondary" on:click={(e) => testConsoleError(e)}>Console error</Button>
		</Container>

		<hr class="mb-s mt-s" />

		<Container padding="0">
			<Text styleType="h2" class="mb-m text-bold">Reset PP and GTC</Text>
			<ResetPPandGTC />
		</Container>

		<hr class="mb-s mt-s" />

		<Container padding="0">
			<Text styleType="h2" class="mb-m text-bold">Reset Rate!</Text>
			<ResetRate />
		</Container>

		<hr class="mb-s mt-s" />

		<Container padding="0">
			<Text styleType="h2" class="mb-m text-bold">Biometrics</Text>
			<Text styleType="body-small" class="mb-s">Ask for biometrics auth</Text>
			{#if $NativeApp}
				<Button on:click={() => sendBiometricsRequest()}>ASK ME!</Button>
				{#if $os !== 'IOS'}
					<Button on:click={() => askForSecurity()}>Go to security settings</Button>
				{/if}
				<Button on:click={() => clearPinUnlockedDevices()}>Clear Pin Unlocked Devices</Button>
				{#if biometricAuthResponse}
					<Text>Response: {JSON.stringify(biometricAuthResponse.biometry)}</Text>
					<Text>Error: {JSON.stringify(biometricAuthResponse.error) || ''}</Text>
				{/if}
			{:else}
				<Text styleType="body-small" class="mt-s mb-s text-warning"
					>Only available in Native App.</Text
				>
			{/if}
		</Container>
		<hr class="mb-s mt-s" />

		<Container padding="0">
			<Text styleType="h2" class="mb-m">Send Only local commands</Text>
			<SendLocalCommandsUtility />
		</Container>

		<hr class="mb-s mt-s" />

		<Container padding="0">
			<Text class="mb-m">Get main route location / landing url</Text>
			<IconButton
				class="mb-s"
				on:click={() => getLandingHref()}
				icon="fas fa-clipboard"
				aria-label={$format('copy_to_clipboard', {
					default: 'Copy landing URL to clipboard',
				})}
			/>
			<Text class="mb-m">got to main route location</Text>
			<IconButton
				on:click={() => push(getLandingHref())}
				icon="fas fa-duck"
				aria-label={$format('navigate_to_main_route', {
					default: 'Navigate to main route',
				})}
			/>
		</Container>

		<hr class="mb-s mt-s" />

		<Container padding="0">
			<Text class="mb-m">Reset Alexa Integration Prompt</Text>
			<ResetAlexaIntegrationPrompt />
		</Container>

		<hr class="mb-s mt-s" />

		<Container padding="0">
			<Text class="mb-m">Reset Newsletter</Text>
			<ResetNewsletter />
		</Container>

		<hr class="mb-s mt-s" />

		<Container padding="0">
			<Text class="mb-m">Reset Premium EventLog Ads</Text>
			<ResetPremiumEventLogAds />
		</Container>

		<hr class="mb-s mt-s" />

		<Container padding="0">
			<Text class="mb-m">Reset Premium Scene Condition Ads</Text>
			<ResetPremiumSceneConditionAds />
		</Container>

		<hr class="mb-s mt-s" />

		<Container padding="0">
			<Text class="mb-m">Reset Premium Weather Widget Ads</Text>
			<ResetPremiumWeatherWidgetAds />
		</Container>

		<hr class="mb-s mt-s" />

		<Container padding="0">
			<Text class="mb-m">Test Confetti</Text>
			<TestConfetti bind:testConfetti />
		</Container>

		<hr class="mb-s mt-s" />

		{#if testConfetti}
			<Confetti
				delay={[0, 200]}
				amount={false ? 100 : 900}
				y={[-2, 2]}
				x={false ? [-1.5, 1.5] : [-5, 5]}
				fallDistance={'200px'}
			/>
		{/if}

		<Container padding="0">
			<Text class="mb-m">Test Global Temperature Units</Text>
			<ResetGlobalTempUnit />
		</Container>

		<hr class="mb-s mt-s" />

		<Container padding="0">
			<Text styleType="h2" class="mb-m">Verivox Energy Tariff</Text>
			<Button
				variant="secondary"
				class="width-md-xl width-sm-full mb-m"
				on:click={enableVerivoxIntegration}
			>
				Show Verivox integration
			</Button>
			<Button
				variant="danger-secondary"
				class="width-md-xl width-sm-full mb-m"
				on:click={removeVerivoxHomeData}
			>
				Remove Verivox home data
			</Button>
			<Text class="mb-m">Color Scheme</Text>
			<div class="energy-price-scheme-selector">
				{#each schemeKeys as scheme}
					<button
						class="energy-scheme-btn"
						class:active={energyPriceScheme === scheme}
						style="background: {energyPriceColorSchemes.schemes[scheme]}"
						on:click={() => handleEnergyPriceSchemeChange(scheme)}
						type="button"
					>
						{scheme.replace('scheme', '')}
					</button>
				{/each}
			</div>
			<hr class="mb-m mt-m" />
			<Text class="mb-m">Clear Data</Text>
			<Stack gap="s" class="d-flex align-items-center">
				<Button
					variant="secondary"
					class="width-md-xl width-sm-full"
					on:click={clearCachedPostalCode}
				>
					Clear Cached Postal Code
				</Button>
				<Button
					variant="secondary"
					class="width-md-xl width-sm-full"
					on:click={clearEnergyPriceDismissal}
				>
					Clear Dismissal State
				</Button>
			</Stack>
		</Container>
	</Stack>
</Modal>

<style>
	.energy-price-scheme-selector {
		display: flex;
		align-items: center;
		gap: 8px;
		flex-wrap: wrap;
	}

	.energy-scheme-btn {
		width: 40px;
		height: 40px;
		border-radius: 8px;
		border: 2px solid transparent;
		cursor: pointer;
		transition: all 0.2s ease;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 12px;
		font-weight: 700;
		color: #ffffff;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	}

	.energy-scheme-btn:hover {
		transform: scale(1.1);
		box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
	}

	.energy-scheme-btn.active {
		border-color: var(--color-primary, #3b82f6);
		box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.3);
	}

	.env-monitor-iframe {
		height: 400px;
		min-height: 360px;
		border: 0;
		display: block;
	}
</style>
